import Api from '../services/api.js';

export function authAccountRequest() {
  return {
    type: 'AUTH_ACCOUNT_REQUEST'
  };
}

export function authAccountSuccess(data) {
  return {
    type: 'AUTH_ACCOUNT_SUCCESS',
    data: data
  };
}

export function authAccountFailure(exception) {
  return {
    type: 'AUTH_ACCOUNT_FAILURE',
    exception: exception
  };
}

export function authAccount(authorisationCode) {
  return (dispatch) => {
    dispatch(authAccountRequest());
    const api = new Api();
    let url = `/__api/stripe_account_token?code=${authorisationCode}`;
    return api
      .post(url, { headers: { Region: 'AU' } })
      .then((response) => dispatch(authAccountSuccess(response.data)))
      .catch((err) => dispatch(authAccountFailure(err)));
  };
}

export function submitStripePaymentRequest() {
  return {
    type: 'STRIPE_PAYMENT_REQUEST'
  };
}

export function submitStripePaymentSuccess(data) {
  return {
    type: 'STRIPE_PAYMENT_SUCCESS',
    data: data
  };
}

export function submitStripePaymentFailure(exception) {
  return {
    type: 'STRIPE_PAYMENT_FAILURE',
    exception: exception
  };
}

export function submitStripePayment(requestBody) {
  return (dispatch) => {
    dispatch(submitStripePaymentRequest());
    const api = new Api();
    let url = '/__api/stripe_payment';
    return api
      .post(url, requestBody, { headers: { Region: 'AU' } })
      .then((response) => dispatch(submitStripePaymentSuccess(response.data)))
      .catch((err) => dispatch(submitStripePaymentFailure(err)));
  };
}

export function getChargeRequest() {
  return {
    type: 'GET_CHARGE_REQUEST'
  };
}

export function getChargeSuccess(data) {
  return {
    type: 'GET_CHARGE_SUCCESS',
    data: data
  };
}

export function getChargeFailure(exception) {
  return {
    type: 'GET_CHARGE_FAILURE',
    exception: exception
  };
}

export function getCharge(chargeId) {
  return (dispatch) => {
    dispatch(getChargeRequest());
    const api = new Api();
    let url = `/__api/charges/${chargeId}`;
    return api
      .get(url, { headers: { Region: 'AU' } })
      .then((response) => dispatch(getChargeSuccess(response.data)))
      .catch((err) => dispatch(getChargeFailure(err)));
  };
}
